import { Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import InputText from '../inputs/input-text';
import { RowProps } from './types';
import IconCopy from '../icons/copy-two';

import styles from './transaction.module.css';

export default function SidepanelSortCodeRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  children,
  borderless = false,
  error,
  disabled,
  tabIndex,
  copyEnabled,
  fieldValue,
  clearErrors,
}: RowProps): React.JSX.Element {
  const [sortCode, setSortCode] = useState('');
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(sortCode);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  useEffect(() => {
    if (value || fieldValue) {
      setSortCode((value as string) || (fieldValue as string));
    }
  }, [value, fieldValue]);

  let content;

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        rules={{ required: false }}
        defaultValue={value}
        render={({ field: { value: valueInput, onChange } }) => {
          const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
            let inputValue = valueInput;

            if (event.key !== 'Backspace') {
              const regex = /.{1,2}/g;

              inputValue = valueInput
                ?.replace(/[^0-9]/g, '')
                ?.match(regex)
                ?.join('-');
            }

            setSortCode(inputValue as string);
          };
          return (
            <InputText
              title={title}
              name={name}
              value={sortCode}
              placeholder={placeholder as string}
              className={`${borderless ? 'borderless' : ''} `}
              error={error}
              disabled={disabled}
              onKeyUp={onKeyUp}
              maxLength={8}
              tabIndex={tabIndex}
              onChange={(e) => {
                if (clearErrors && error) {
                  clearErrors([name]);
                }

                onChange(e);

                if (!e.target.value) {
                  setSortCode('');
                }
              }}
            />
          );
        }}
      />
    );
  } else {
    content = children || value;
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${
                styles.autocompleteCopyButton
              } ${copyIsSuccess ? styles.success : ''}`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
